import { type ReactNode, useCallback, useState } from 'react';
import { useEffectOnce } from 'react-use';
import {
  REPORT_CONTEXT_DEFAULTS,
  ReportContext,
  type ReportContextType,
} from './ReportContext';

interface Props {
  children: ReactNode;
}

export const ReportProvider = ({ children }: Props) => {
  const [contextValue, setContextValue] = useState(REPORT_CONTEXT_DEFAULTS);

  const updateContext = useCallback(
    (newContext: Partial<ReportContextType>) => {
      setContextValue((current) => ({
        ...current,
        ...newContext,
      }));
    },
    [setContextValue],
  );

  useEffectOnce(() => {
    updateContext({ updateContext });
  });

  return (
    <ReportContext.Provider value={contextValue}>
      {children}
    </ReportContext.Provider>
  );
};
